import { defaultFetchAnon } from './baseApi';

export type KeyCloakAvailability = {
	enabled: boolean;
	url: string;
};

export const getKeycloakAvailability = async () => {
	return defaultFetchAnon<KeyCloakAvailability>('/kc');
};

export type UserData = {
	id: string;
	nickname: string;
	name: string;
	avatar: string;	
	email: string,
	roles: [],
	companies: [],
	token: string,
	kcToken: string,
	firstName: string,
	lastName: string,
	isOe: boolean,
	attributes: {
		id: string;
		nickname: string;
		name: string;
		email: string;
	};
	refreshToken: string | null;
	expiresIn: number | null;
	approvedScopes: null;
	accessTokenResponseBody: null;
};

export const getKeycloakUserData = async (code: string) => {
	return defaultFetchAnon<UserData>(`/kc?code=${code}`);
};
